import { Branding } from "@mercdev.com/mercurial-ui/branding";
import { useServices } from "hooks/useServices";

const Footer = () => {
  const services = useServices();

  return (
    <footer className="app__footer mk-ui-paper">
      <div className="app__footer-wrapper">
        <div>
          <p className="app__footer-header">
            Shortener, 2022–{new Date().getFullYear()}
          </p>
          <a
            className="app__footer-link"
            href="mailto:artdir@mercurydevelopment.com"
          >
            artdir@mercurydevelopment.com
          </a>
        </div>
        <div className="app__footer-links">
          {services.map((item) => {
            return (
              <li
                role="tab"
                tabIndex={0}
                key={`mk-ui-menu-branding-item-${item.name}`}
                className={"app__footer-icon"}
                onKeyDown={(event) => {
                  if (
                    item.onClick &&
                    (event.code === "Space" || event.code === "Enter")
                  ) {
                    item.onClick();
                  }
                }}
              >
                <a
                  className="mk-ui-menu-branding__icon"
                  href={item.link}
                  target="_blank"
                  rel="noreferrer"
                >
                  <Branding isGrayscale withoutAnimation>
                    <Branding.Icon icon={item.icon} iconSize="medium" />
                  </Branding>
                </a>
              </li>
            );
          })}
        </div>
        <div>
          <p className="app__footer-header">
            © Mercury Development, 1999–{new Date().getFullYear()}
          </p>
          <a
            className="app__footer-link"
            rel="noreferrer"
            target="_blank"
            href="https://mercdev.com"
          >
            mercdev.com
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
